var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P } from '@pacem/pacem-core';
import { PacemTrackerElement } from './types';
//namespace Pacem.Components.Logging {
let PacemFpsElement = class PacemFpsElement extends PacemTrackerElement {
    constructor() {
        super();
    }
    _start(t0 = Date.now()) {
        this._handle = requestAnimationFrame(() => {
            const t1 = Date.now(), msecs = t1 - t0;
            // sets new entry
            this.entry = Math.min(60, 1000.0 / msecs);
            this._start(t1);
        });
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._start();
    }
    disconnectedCallback() {
        cancelAnimationFrame(this._handle);
        super.disconnectedCallback();
    }
};
PacemFpsElement = __decorate([
    CustomElement({
        tagName: P + '-fps'
    })
], PacemFpsElement);
export { PacemFpsElement };
//}
